$(document).ready(function () {
  quickView();
});

let productData, options, variants, swatchOption, swatchMethod, templateSuffix;

function quickView() {
  $(document).on("click", ".quick-view-button", function (e) {
    e.preventDefault();
    const $button = $(this);
    const productHandle = $button.data("handle");
    productData = JSON.parse($button.attr("data-product-json"));
    const productMetafields = JSON.parse($button.attr("data-metafields"));
    const featuredImage = $button.data("featured-image");
    variants = JSON.parse($button.attr("data-variants"));
    options = JSON.parse($button.attr("data-options"));
    const selectedVariantId = $button.data("selected-variant-id");
    const productUrl = $button.data("product-url");
    swatchOption = $button.data("swatch-option");
    swatchMethod = $button.data("swatch-method");
    templateSuffix = $button.data("template-suffix");

    // test
    fetch(`/templates/product.json`)
      .then((res) => {
        res.json().then(console.log)
      }).catch((err) => {
        console.log("fetch error", err);
      })
    
    // iterating through product images and create variant images list
    const variantImages = {};
    variants.forEach((variant) => {
      if (variant.featured_image) {
        variantImages[variant.featured_image.src] = [];
      }
    });
    let prevImage = "";
    productData.media.forEach((media) => {
      if (variantImages[media.src]) {
        variantImages[media.src].push(media.src);
        prevImage = media.src;
      } else if (prevImage) {
        variantImages[prevImage].push(media.src);
      }
    });

    // If quick-view already exists for this product, return
    if ($("#quick-view." + productHandle).length) return;

    // Append quick-view container if not already present
    if (!$("#quick-view").length) {
      $("body").append('<div id="quick-view">' + qv_content + "</div>");
      // Close quick-view on backdrop or close button click
      $("#qv-close, .qv-backdrop").click(function () {
        $("#quick-view").remove();
      });
    }

    // Add product handle as a class for quick-view
    $("#quick-view").addClass(productHandle);

    // Update product details in quick-view
    $(".qv-product-title").text(productData.title);
    $(".qv-description-content").html(productMetafields.shop_description);
    
    $(".qv-view-product").attr("href", "/products/" + productHandle);

    // set reviews
    const dataReviewSnippet = JSON.parse($button.data("review-snippet"));
    $(".qv-product-review").html(dataReviewSnippet);

    // Update vendor and product type information
    updateVendorAndType(productData);

    // productData.images.forEach(image => {
    //     const imageEmbed = `<img src="${image.replace(/(\.jpg|\.png)/, "_800x$1")}">`;
    //     $(".qv-product-images").append(imageEmbed);
    // });

    function renderImages(featuredImage) {
      // make sure to load all images if there are no variants
      let imagesToRender = variantImages[featuredImage];
      if (!imagesToRender) imagesToRender = productData.images;

      $(".qv-product-images").empty();
      imagesToRender.forEach((media) => {
        if (!media) return;
        const imageEmbed = `<img src="${media.replace(
          /(\.jpg|\.png)/,
          "_800x$1"
        )}">`;
        $(".qv-product-images").append(imageEmbed);
      });
    }
    renderImages(
      (variants.find((v) => v.available) || variants[0]).featured_image?.src
    );

    // Load product options
    loadProductOptions();

    // Render accordion with new fields
    renderAccordion(productMetafields);

    // Remove any existing event listeners to prevent duplicates
    $(document).off("change", ".qv-option-input");
    $(document).off("click", ".swatch-item");

    // Add event listeners for both radio buttons and swatches
    $(document).on("change", ".qv-option-input", function (e) {
      // update variant text
      const element = event.target;
      const name = element.getAttribute("data-qv-option-title");
      const value = element.getAttribute("value");
      const optionIndex = element.getAttribute("data-option-index");

      $(`[data-qv-option-name="${name.toLowerCase()}"]`).text(
        `${name} - ${value}`
      );

      // FIX: get values from other swatch inputs and filter it accordingly

      const variant = variants.find(
        (variant) =>
          variant.options[parseInt(optionIndex)].toLowerCase() ==
          value?.toLowerCase()
      );

      if (variant) {
        renderImages(variant.featured_image.src);
      }

      updatePricing(productData);
    });

    $(document).on("click", ".swatch-item", function (e) {
      const value = $(this).data("option-item");
      const optionIndex = options.findIndex(
        (option) => option.name.toLowerCase() === swatchOption.toLowerCase()
      );

      if (optionIndex !== -1) {
        // Update both mobile and desktop swatches
        $(".swatch-item").removeClass("selected");
        $(`.swatch-item[data-option-item="${value}"]`).addClass("selected");

        // Update the corresponding radio input
        $(`.qv-product-option:eq(${optionIndex}) input[value="${value}"]`)
          .prop("checked", true)
          .change();

        const variant = variants.find(
          (variant) => variant.option1.toLowerCase() == value.toLowerCase()
        );
        renderImages(variant.featured_image.src);

        if (variant) {
          // Change variant text
          $(`[data-qv-option-name="${swatchOption.toLowerCase()}"]`).text(
            `${swatchOption} - ${variant.options[optionIndex]}`
          );

          // Scroll to the product
          const $element = $(
            `[data-media-image-id="${variant.featured_media.id}"]`
          );

          if ($element.length) {
            // Scroll the element into view
            const container = $(".qv-product-images-wrapper");
            const elementLeft = $element.offset().left;
            const containerLeft = container.offset().left;
            const scrollPosition =
              elementLeft - containerLeft + container.scrollLeft();

            // Scroll the container only on the X-axis
            container.animate(
              {
                scrollLeft: scrollPosition,
              },
              800
            );
          }
        }

        // Explicitly trigger price update
        updatePricing(productData);
      }
    });

    $(document).on("click", ".qv-add-button", function () {
      const selectedOptions = getSelectedOptions();
      const quantity = 1;

      let matchingVariant;

      if (productData.variants.length === 1) {
        matchingVariant = productData.variants[0];
      } else {
        matchingVariant = productData.variants.find((v) =>
          productData.options.every(
            (option, index) =>
              v[`option${index + 1}`].toLowerCase() ===
              selectedOptions[index].toLowerCase() // Case-insensitive comparison
          )
        );
      }

      if (matchingVariant) {
        processCart(matchingVariant.id, quantity);
      } else {
        console.error("No matching variant found.");
      }
    });
  });
}

function createSwatchElement(value, index) {
  const swatch = document.createElement("div");
  swatch.classList.add("swatch-item");
  swatch.dataset.optionItem = value.toLowerCase();

  // Find the variant that matches this option value
  const matchingVariant = variants.find((variant) =>
    variant.options.some(
      (option) => option.toLowerCase() === value.toLowerCase()
    )
  );

  if (matchingVariant && matchingVariant.featured_image) {
    // Use the variant's featured image
    swatch.style.backgroundImage = `url(${matchingVariant.featured_image.src})`;
  } else if (swatchMethod === "color") {
    swatch.style.backgroundColor = value.toLowerCase().replace(" ", "");
  } else if (swatchMethod === "image") {
    // Fallback to the original image method if no variant image is available
    swatch.style.backgroundImage = `url(${value
      .toLowerCase()
      .replace(" ", "-")}.png)`;
  }

  swatch.addEventListener("click", function (e) {
    e.preventDefault();
    const optionIndex = options.findIndex(
      (option) => option.name.toLowerCase() === swatchOption.toLowerCase()
    );
    if (optionIndex !== -1) {
      $(`.qv-product-option:eq(${optionIndex}) input[value="${value}"]`)
        .prop("checked", true)
        .change();
    }
  });

  return swatch;
}

function loadProductOptions() {
  $(".qv-product-options").empty();
  $(".qv-mobile-swatches").empty();

  // Get initial variant
  const initialVariant = variants.find((v) => v.available) || variants[0];

  options.forEach((option, index) => {
    if (option.name !== "Title" || variants.length > 1) {
      const optionKey = option.name.split(" ").join("-").toLowerCase();

      // Escape special characters in optionKey for use in selectors
      const escapedOptionKey = optionKey.replace(/[^a-zA-Z0-9]+/g, "-");

      if (option.name.toLowerCase() === swatchOption.toLowerCase()) {
        // Create swatches
        const swatchContainer = $("<div>").addClass("swatch-container");

        option.values.forEach((value, i) => {
          const swatch = createSwatchElement(value, i);
          swatchContainer.append(swatch);
        });

        // Append swatches to mobile container without the title
        $(".qv-mobile-swatches").append(`
            <span class="qv-option-name" data-qv-option-name="${option.name.toLowerCase()}">
                ${option.name} - ${initialVariant.options[index]}
            </span>
        `);

        $(".qv-mobile-swatches").append(swatchContainer.clone());

        // Append swatches to desktop container with title
        $(".qv-product-options").append(`
            <div class="qv-product-option ${escapedOptionKey} desktop-only" data-option-index="${index}">
                <span class="qv-option-name" data-qv-option-name="${option.name.toLowerCase()}">
                    ${option.name} - ${initialVariant.options[index]}
                </span>
            <div class="qv-options"></div>
            </div>
        `);

        $(`.qv-product-option.${escapedOptionKey} .qv-options`).append(
          swatchContainer
        );

        // Set initial swatch selection
        const initialValue = initialVariant[`option${index + 1}`];

        if (initialValue) {
          const swatch = $(
            `.swatch-item[data-option-item="${initialValue.toLowerCase()}"]`
          );
          if (swatch.length) {
            swatch.addClass("selected");
          }
        }
      } else {
        // Handle regular options
        $(".qv-product-options").append(`
            <div class="qv-product-option ${escapedOptionKey}" data-option-index="${index}">
                <span class="qv-option-name" data-qv-option-name="${option.name.toLowerCase()}">
                    ${option.name} - ${initialVariant.options[index]}
                </span>
            <div class="qv-options"></div>
            </div>
        `);

        option.values.forEach((value, i) => {
          const inputId = `qv-option-${optionKey}-${i}`;
          const isChecked = initialVariant[`option${index + 1}`] === value;

          // $(`.qv-product-option .qv-options`).append(`
          $(`.qv-product-option.${escapedOptionKey} .qv-options`).append(`
                <div class="qv-option-item">
                    <input class="qv-option-input" 
                            id="${inputId}" 
                            type="radio" 
                            name="option-${index}"
                            data-option-index="${index}"
                            value="${value}"
                            ${isChecked ? "checked" : ""} 
                            data-qv-option-title="${option.name}"
                    />
                    <label for="${inputId}">${value}</label>
                </div>
            `);
        });
      }
    }
  });

  // Initial price update after options are loaded
  updatePricing(productData);
}

// meta fields mapping

const metafieldsMapping = {
  material_care: "Material & Care",
  shipping_returns: "Shipping & Returns",
  product_faqs: "Product FAQs",
  what_s_inside: "What's Inside",
  "what_s_inside-box": "Unbox Me",
};

const bundleTemplateKeys = [
  "what_s_inside",
  "what_s_inside-box",
  "dimensions",
  "our_giftboxes",
];

const metafieldsOrder = {
  "what_s_inside-box": 1,
  "ingredients": 2,
  "material_care": 3,
  "dimensions": 4,
  "size_chart": 5,
  "features": 6,
  "more_info": 7,
  "product_faqs": 8,
  "about_the_brand": 9,
}

function renderAccordion(productMetafields) {
  const $accordionContainer = $("#qv-accordion");
  if (!$accordionContainer.length) {
    return;
  }
  $accordionContainer.empty();

  let accordionItems = Object.keys(productMetafields).map((key, idx) => {
    return {
      title:
        metafieldsMapping[key] ||
        key
          .split("_")
          .join(" ")
          .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()),
      content: renderRichText(productMetafields[key]),
      key,
      open: false,
      key,
    };
  });

  accordionItems = accordionItems.filter((item) => {
    if (templateSuffix === "bundle-template") {
      return bundleTemplateKeys.includes(item.key);
    }

    return true; // Return all items if templateSuffix is not "bundle-template"
  });

  // sort accordion items
  accordionItems = accordionItems.sort((a, b) => {
    const orderA = metafieldsOrder[a.key] || Number.MAX_VALUE;
    const orderB = metafieldsOrder[b.key] || Number.MAX_VALUE;
    return orderA - orderB;
  })

  // const accordionItems = [
  //   {
  //     title: "Features",
  //     content: renderRichText(productMetafields.features),
  //     open: false,
  //   },
  //   {
  //     title: "Dimensions",
  //     content: renderRichText(productMetafields.dimensions),
  //     open: false,
  //   },
  //   {
  //     title: "Ingredients",
  //     content: renderRichText(productMetafields.ingredients),
  //     open: false,
  //   },
  //   {
  //     title: "Size Chart",
  //     content: renderRichText(productMetafields.size_chart),
  //     open: false,
  //   },
  //   {
  //     title: "Material & Care",
  //     content: renderRichText(productMetafields.material_care),
  //     open: false,
  //   },
  //   {
  //     title: "More Info",
  //     content: renderRichText(productMetafields.more_info),
  //     open: false,
  //   },
  //   {
  //     title: "About The Brand",
  //     content: renderRichText(productMetafields.about_the_brand),
  //     open: false,
  //   },
  // ];

  accordionItems.forEach((item) => {
    if (item.content) {
      const $accordionItem = createAccordionItem(
        item.title,
        item.content,
        false
      ); // Pass false to not open any by default
      $accordionContainer.append($accordionItem);
    }
  });
}

function createAccordionItem(title, content, isOpen = false) {
  const $details = $("<details>").addClass("cc-accordion-item");
  if (isOpen) {
    $details.attr("open", "");
  }

  const $summary = $("<summary>")
    .addClass("cc-accordion-item__title")
    .text(title);

  const $panel = $("<div>").addClass("cc-accordion-item__panel");

  const $contentDiv = $("<div>")
    .addClass("cc-accordion-item__content rte")
    .html(content);

  $panel.append($contentDiv);
  $details.append($summary).append($panel);

  return $details;
}

function renderRichText(richTextData) {
  if (!richTextData || !richTextData.children) return "";

  return richTextData.children.map((node) => renderNode(node)).join("");
}

function renderNode(node) {
  switch (node.type) {
    case "paragraph":
      return `<p>${node.children
        .map((child) => renderNode(child))
        .join("")}</p>`;
    case "heading":
      return `<h${node.level}>${node.children
        .map((child) => renderNode(child))
        .join("")}</h${node.level}>`;
    case "text":
      let text = node.value;
      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;
      return text;
    case "link":
      return `<a href="${node.url}" ${
        node.target ? `target="${node.target}"` : ""
      }>${node.children.map((child) => renderNode(child)).join("")}</a>`;
    case "list":
      const listType = node.listType === "ordered" ? "ol" : "ul";
      return `<${listType}>${node.children
        .map((child) => renderNode(child))
        .join("")}</${listType}>`;
    case "list-item":
      return `<li>${node.children
        .map((child) => renderNode(child))
        .join("")}</li>`;
    default:
      return "";
  }
}

function updateVendorAndType(productData) {
  const vendorUrl = productData.vendor
    ? `/collections/vendors?q=${encodeURIComponent(productData.vendor)}`
    : "#";
  const typeUrl = productData.type
    ? `/collections/types?q=${encodeURIComponent(productData.type)}`
    : "#";

  let vendorTypeHtml = "";

  if (productData.vendor) {
    vendorTypeHtml += `
      <span class="brand">
        <a data-cc-animate-click href="${vendorUrl}">${productData.vendor}</a>
      </span>
    `;
  }

  if (productData.type) {
    if (productData.vendor) {
      vendorTypeHtml += '<span class="cc-bullet">&bull;</span>';
    }
    vendorTypeHtml += `
      <span class="type">
        <a data-cc-animate-click href="${typeUrl}">${productData.type}</a>
      </span>
    `;
  }

  if (vendorTypeHtml) {
    $(".qv-product-title").after(`
      <div class="vendor product-detail__gap-sm">
        ${vendorTypeHtml}
      </div>
    `);
  }
}

function updatePricing(productData) {
  let matchingVariant;
  const selectedOptions = getSelectedOptions();

  if (productData.variants.length === 1) {
    matchingVariant = productData.variants[0];
  } else if (selectedOptions.length === productData.options.length) {
    // Only try to match variant if all options are selected
    matchingVariant = productData.variants.find((variant) => {
      return selectedOptions.every((selectedOption, index) => {
        const optionIndex = `option${index + 1}`;
        return (
          variant[optionIndex].toLowerCase() === selectedOption.toLowerCase()
        );
      });
    });
  }

  if (matchingVariant) {
    const price = (matchingVariant.price / 100).toFixed(2);
    const compareAtPrice = matchingVariant.compare_at_price
      ? (matchingVariant.compare_at_price / 100).toFixed(2)
      : null;

    // Update price display
    $(".qv-product-price").text(`$${price}`);

    // Handle compare at price
    const $originalPriceElement = $(".qv-product-original-price");
    const $productDiscountElement = $(".qv-product-discount");

    if (compareAtPrice && parseFloat(compareAtPrice) > parseFloat(price)) {
      $originalPriceElement.text(`$${compareAtPrice}`).show();

      const discountPercentage = Math.round(
        ((compareAtPrice - price) * 100.0) / compareAtPrice
      );

      $productDiscountElement.text(`${discountPercentage} % OFF`).show();
    } else {
      $originalPriceElement.hide();
      $productDiscountElement.hide();
    }

    // Update add to cart button state
    const $addButton = $(".qv-add-button");
    if (matchingVariant.available) {
      $addButton
        .prop("disabled", false)
        .val("Add to Cart")
        .removeClass("sold-out unavailable");
    } else {
      $addButton
        .prop("disabled", true)
        .val("Sold Out")
        .removeClass("unavailable")
        .addClass("sold-out");
    }
  } else {
    // Show first variant price until all options are selected
    const defaultVariant = productData.variants[0];

    console.log("default variant", defaultVariant);

    if (defaultVariant) {
      const price = (defaultVariant.price / 100).toFixed(2);

      $(".qv-product-price").text(`$${price}`);
      $(".qv-product-original-price").hide();
      $(".qv-product-discount").hide();
      $(".qv-add-button")
        .prop("disabled", true)
        .val("Select options")
        .removeClass("sold-out")
        .addClass("unavailable");
    }
  }
}

function getSelectedOptions() {
  const selectedOptions = [];

  $(".qv-product-option").each(function () {
    const $option = $(this);
    let selectedValue;

    // Check if this is a swatch option
    if ($option.find(".swatch-item.selected").length) {
      selectedValue = $option.find(".swatch-item.selected").data("option-item");
    } else {
      // Regular radio button option
      selectedValue = $option.find(".qv-option-input:checked").val();
    }

    if (selectedValue) {
      selectedOptions.push(selectedValue);
    }
  });

  return selectedOptions;
}

function processCart(variantId, quantity) {
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    dataType: "json",
    data: { quantity: quantity, id: variantId },
  })
    .done(function () {
      $(".qv-add-to-cart-response")
        .html(`Item added to cart. <a href="/cart">View cart</a>`)
        .addClass("success");
    })
    .fail(function (jqXHR) {
      const errorData = JSON.parse(jqXHR.responseText);
      $(".qv-add-to-cart-response")
        .html(`<b>ERROR:</b> ${errorData.description}`)
        .addClass("error");
    });
}
